import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=56723f4a&scoped=true&"
import script from "./Header2.vue?vue&type=script&lang=js&"
export * from "./Header2.vue?vue&type=script&lang=js&"
import style0 from "./Header2.vue?vue&type=style&index=0&id=56723f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56723f4a",
  null
  
)

export default component.exports